module.exports = __webpack_public_path__ + "img/cartic.78dd76a5.png";